/**
 * Assert that a condition is truthy.
 * @param condition The condition to assert.
 * @param message A message to include in the error if the assertion fails.
 */
export function assert(
  condition: unknown,
  message: string = "Assertion failed"
): asserts condition {
  if (!condition) {
    throw createAssertionError(assert, message)
  }
}

/**
 * Dangerously cast a value to a specific type. Performs no actual runtime check.
 * @param value The value to assert.
 */
export function unsafeCast<T = never>(value: unknown): asserts value is T {}

/**
 * Create an assertion error.
 * @param caller The function that is creating the error. This is used to eliminate the assertion function from the stack trace.
 * @param message The message to include in the error.
 */
function createAssertionError(
  caller: (...args: any[]) => any,
  message: string
) {
  const error = new Error(message)
  error.name = "AssertError"
  if (
    "captureStackTrace" in Error &&
    typeof Error.captureStackTrace === "function"
  ) {
    Error.captureStackTrace(error, caller)
  }
  return error
}
